import React from 'react'
import { Dialog, DialogContent } from '@mui/material'
import { CoursePriceDetailsState } from '../../../../../features/types'
import Stepper from './components/Stepper'

interface Props {
    open: boolean
    handleClose: () => void
    editCoursePrice?: CoursePriceDetailsState
}

const CoursePriceDialog: React.FC<Props> = ({
    open = false,
    handleClose,
    editCoursePrice,
}) => {
    return (
        <Dialog
            maxWidth={'lg'}
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogContent>
                <Stepper editCoursePrice={editCoursePrice} />
            </DialogContent>
        </Dialog>
    )
}

export default CoursePriceDialog
